module.exports = __webpack_public_path__ + "static/media/Lunken.e7d35c34.m4a";